<nz-badge nzStandalone [nzCount]="iconTemplate" class="needs-review-state"></nz-badge>
<ng-template #iconTemplate>
    <dpqa-icon iconName="quest" [iconSize]="2" />
</ng-template>
